import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as string | null;

const slice = createSlice({
  name: '$notes',
  initialState,
  reducers: {
    setShadowNotes: (state, action: PayloadAction<string>) => {
      return action.payload;
    },
  },
});

export const { setShadowNotes } = slice.actions;

export default slice.reducer;
